import React from 'react';
import { Book, Calendar, GraduationCap, Package, AlertCircle } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto md:p-6 bg-gray-50 min-h-screen">
      <div className="bg-white rounded-lg shadow-sm p-8 mt-20 md:my-20">
        <div className="flex items-center justify-center mb-8">
          <Book className="h-8 w-8 text-primary mr-3" />
          <h1 className="text-3xl font-bold">Terms of Service</h1>
        </div>

        <div className="space-y-8">
          <section>
            <div className="flex items-center gap-2 mb-4">
              <Calendar className="h-5 w-5 text-primary" />
              <h2 className="text-2xl font-semibold">Spa Services</h2>
            </div>
            <div className="text-gray-600 space-y-4">
              <p>By booking our services, you agree to the following terms:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Appointments must be booked in advance with accurate personal information</li>
                <li>24-hour notice is required for cancellations; late cancellations may incur charges</li>
                <li>Arrive 10 minutes before your scheduled appointment time</li>
                <li>Inform us of any health conditions or medications that may affect treatment</li>
                <li>Payment is required at the time of booking a service</li>
                <li>We reserve the right to refuse service at our discretion</li>
              </ul>
            </div>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-4">
              <GraduationCap className="h-5 w-5 text-primary" />
              <h2 className="text-2xl font-semibold">Training Programs</h2>
            </div>
            <div className="text-gray-600 space-y-4">
              <p>For students enrolled in our massage training programs:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Full payment is required to secure enrollment</li>
                <li>Course materials are proprietary and for personal use only</li>
                <li>Regular attendance is mandatory for certification</li>
                <li>Students must maintain professional conduct during training</li>
                <li>Certificates will be issued only upon successful completion</li>
                <li>We reserve the right to dismiss students for misconduct</li>
              </ul>
            </div>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-4">
              <Package className="h-5 w-5 text-primary" />
              <h2 className="text-2xl font-semibold">Product Purchases</h2>
            </div>
            <div className="text-gray-600 space-y-4">
              <p>For skincare and other product purchases:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>We kindly inform you that all sales are final.</li> 
                <li>Once a product has been purchased and confirmed, <br />it cannot be returned or 
                  exchanged, and refunds will not be issued.</li>
                <li>We are not liable for allergic reactions or improper use</li>
                <li> We appreciate your understanding.</li>
              </ul>
            </div>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-4">
              <AlertCircle className="h-5 w-5 text-primary" />
              <h2 className="text-2xl font-semibold">Liability & Disclaimers</h2>
            </div>
            <div className="text-gray-600 space-y-4">
              <p>Important disclaimers:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>We are not liable for personal items lost or damaged on premises</li>
                <li>Clients assume all risks associated with spa services</li>
                <li>We reserve the right to modify services or prices without notice</li>
                <li>Force majeure events beyond the control of the Spa may affect service availability</li>
                <li>This agreement is governed by Nigerian law</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Modifications to Terms</h2>
            <p className="text-gray-600">
              We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of updated terms.
            </p>
          </section>

          <div className="text-sm text-gray-500 mt-8">
            Last updated: [04-02-2025]
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;